// extracted by mini-css-extract-plugin
export default {"content":"Content_content__q67G0","light":"Content_light__+xMMS","dark":"Content_dark__l733g"};